module.exports = __webpack_public_path__ + "static/19-b13ac1b4e2645f729a75810188a3c35b.png";